import { render } from "./whereToBuy.vue?vue&type=template&id=057968cc"
import script from "./whereToBuy.vue?vue&type=script&lang=js"
export * from "./whereToBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__